<template>
  <b-card :title="$t('quickSearches')">
    <div v-if="isCustomerAdministrator" >
      <quick-user-search/>
    </div>
    <div v-if="isCustomerAdministrator" class="mt-4">
      <quick-organization-search/>
    </div>
    <div v-else>{{ $t('notAllowedToAccess') }}</div>
  </b-card>
</template>

<script>
  import { mapGetters } from 'vuex'
  import quickUserSearch from './QuickUserSearch'
  import quickOrganizationSearch from './QuickOrganizationSearch'
  import { isCustomerAdministrator } from '@/services/PermissionService';

  export default {
    name: 'QuickSearches',

    components: {
      quickUserSearch,
      quickOrganizationSearch
    },
    data () {
      return {
        userRoles: []
      }
    },
    computed: {
      ...mapGetters('oidcStore', ['oidcUser']),
      isCustomerAdministrator () {
        return isCustomerAdministrator(this.oidcUser?.username);
      },
    },
    mounted() {
      this.userRoles = this.oidcUser?.roles || [];
    }
  }
</script>
